
import {
  computed,
  defineComponent,
  getCurrentInstance,
  onBeforeMount,
  onMounted,
  reactive,
  toRaw,
  toRefs,
} from "vue";
import { TUINotification } from "@/TUIKit/TUIPlugin";
import Drag from "@/TUIKit/TUIComponents/components/drag";
import { TUICore } from "@/TUIKit";
import { useStore } from "vuex";
import { API_RESULT_CODE } from "@/config/types/common";
import { _cookie } from "@/utils/constant";
import { ElMessage } from "element-plus";
import { useRoute } from "vue-router";
import { JSONToObject } from "@/TUIKit/TUIComponents/container/TUIChat/utils/utils";
import TabBar from "@/components/TabBar.vue";
import { handleErrorPrompts } from "@/TUIKit/TUIComponents/container/utils";
import { getApplyInfoById } from "@/api/company";
import { getJobInfo } from "@/api/common";
import { getWage } from "@/utils/utils";
import Cookies from "js-cookie";
import { CompanyAudit, UserType } from "@/config/types/user";
import { getImUserInfo } from "@/api/user";

const EXPIRETIME = 604800;

export default defineComponent({
  name: "Home",
  components: {
    Drag,
    TabBar,
  },
  setup() {
    const route = useRoute();
    const instance = getCurrentInstance();
    //const locale = useI18nLocale();
    const TUIKit: any = instance?.appContext.config.globalProperties.$TUIKit;
    const store = useStore && useStore();
    const taskList = computed(() => store.state.taskList);
    const tabbar = (toRaw(route).query.value as any)?.tabbar;
    const hideTabbar = tabbar === '0';
    const version: string = TUICore.instance.TIM.VERSION;
    const displayOnlineStatus = computed(() => JSON.parse(store.state.displayOnlineStatus));
    const isMsgNeedReadReceipt = computed(() => JSON.parse(store.state.isMsgNeedReadReceipt));
    const allowNotification = computed(() => JSON.parse(store.state.allowNotification));
    const data = reactive({
      userInfo: TUICore.instance.getStore().TUIProfile.profile,
      env: TUIKit.TUIEnv,
      currentConversationID: "",
      showText: TUICore.instance.isOfficial,
      menuStatus: true,
      showCall: false,
      showCallMini: false,
      conversationLen: 0,
    });

    onBeforeMount(async () => {
      const token = Cookies.get(_cookie.TOKEN);
      if (token) {
        // 用户信息
        const res = await getImUserInfo({}, token);
        const { code, data } = res;
        if (
          code === API_RESULT_CODE.SUCCESS &&
          (data.user_type === UserType.PERSONAL ||
            data.company_verification_status === CompanyAudit.AUDIT_SUCCESS)
        ) {
          login(data);
        } else {
          ElMessage.error("您暂无使用权限，请联系管理员");
        }
      } else {
        window.location.href = `${process.env.VUE_APP_HOST}/login?redirect=${encodeURIComponent(
          window.location.href
        )}`;
      }
    });

    const login = (data: any) => {
      const { im_id, signature } = data;
      const user = {
        userID: im_id,
        userSig: signature,
      };
      // login TUIKit
      TUIKit.login(user)
        .then((res: any) => {
          const options = {
            ...user,
            ...data,
            expire: EXPIRETIME,
          };
          store.commit("setUserInfo", options);
        })
        .catch((error: any) => {
          ElMessage.error(error.message || "IM登录失败");
          //window.location.href = `${
          //  process.env.VUE_APP_HOST
          //}/login?redirect=${encodeURIComponent(window.location.href)}`;
        });
    };

    onMounted(() => {
      // 打开应聘反馈
      const conversationID = (toRaw(route).query.value as any)?.conversationID;
      conversationID && openConversation(conversationID);
      // 创建单聊
      const imId = (toRaw(route).query.value as any)?.imId;
      const applyId = (toRaw(route).query.value as any)?.applyId;
      const jobId = (toRaw(route).query.value as any)?.jobId;
      // 企业端
      imId && applyId && createConversationB2C(imId, applyId);
      // 个人端
      imId && jobId && createConversationC2B(imId, jobId);
      // 客服
      const action = (toRaw(route).query.value as any)?.a;
      const infoStr = localStorage.getItem("TUIKit-userInfo");
      const info = infoStr && JSONToObject(infoStr);
      action === "kefu" &&
        createConversationKefu(store.state.userInfo.im_service || info?.im_service);
      // 默认打开第一条会话
      !data.env.isH5 &&
        Object.keys(toRaw(route).query.value || {}).length === 0 &&
        getConversationListAndOpen();
    });

    TUICore.instance.TUIServer.TUIProfile.getMyProfile().then((res: any) => {
      data.userInfo = res.data;
    });
    const getConversationListAndOpen = async () => {
      TUICore.instance.TUIServer.TUIConversation.getConversationList().then(
        async (imResponse: any) => {
          const conversationList = imResponse.data.conversationList;
          data.conversationLen = conversationList.length;
          data.conversationLen > 0 && (await openConversation(conversationList[0].conversationID));
        }
      );
    };
    // 打开会话
    const openConversation = (conversationID: string) => {
      TUICore.instance.TUIServer.TUIConversation.getConversationProfile(conversationID).then(
        (imResponse: any) => {
          console.log("imResponse:", imResponse);
          const { data } = imResponse;
          data.currentConversationID = conversationID;
          const custom = JSONToObject(data.conversation.lastMessage?.payload?.data);
          // 通知 TUIConversation 添加当前会话
          // Notify TUIConversation to toggle the current conversation
          TUICore.instance.TUIServer.TUIConversation.handleCurrentConversation({
            ...data.conversation,
            businessId: custom?.businessID,
            url: custom?.url,
          });
        }
      );
    };
    // 从投递列表页发起聊天
    const createConversationB2C = (imId: string, applyId: string) => {
      const conversationID = `C2C${imId}`;
      TUICore.instance.TUIServer.TUIConversation.getConversationProfile(conversationID).then(
        async (imResponse: any) => {
          const { data } = imResponse;
          data.currentConversationID = conversationID;
          // 通知 TUIConversation 模块切换当前会话
          await TUICore.instance.TUIServer.TUIConversation.handleCurrentConversation(
            data.conversation
          );
          // 职位卡片
          const res: any = await getApplyInfoById(applyId);
          if (res?.code === API_RESULT_CODE.SUCCESS) {
            const { company_id, company_info, job_id, job_info } = res.data;
            const address = job_info?.district_list?.map((item: any) => item.area_cn);
            const jobInfo = {
              businessID: "job",
              company_id,
              company_logo: company_info?.show_logo,
              company_name: company_info?.show_name,
              company_nature: company_info?.nature_cn,
              job_address: address?.join(","),
              job_attribs: [job_info?.nature_cn, job_info?.experience_cn, job_info?.education_cn],
              job_id,
              job_salary: getWage(
                job_info?.min_wage,
                job_info?.max_wage,
                job_info?.wage_unit,
                job_info?.wage_unit_cn,
                job_info?.is_negotiable,
                job_info?.months
              ),
              job_title: job_info?.job_name,
              version: 4,
            };
            TUICore.instance.TUIServer.TUIChat.sendCustomMessage({
              data: jobInfo,
            });
            // 文本
            TUICore.instance.TUIServer.TUIChat.sendTextMessage(
              "您好，收到您的投递，可以详细聊聊吗？"
            );
          }
        }
      );
    };

    // 从职位详情页发起聊天
    const createConversationC2B = (imId: string, jobId: string) => {
      const conversationID = `C2C${imId}`;
      TUICore.instance.TUIServer.TUIConversation.getConversationProfile(conversationID).then(
        async (imResponse: any) => {
          const { data } = imResponse;
          data.currentConversationID = conversationID;
          // 通知 TUIConversation 模块切换当前会话
          await TUICore.instance.TUIServer.TUIConversation.handleCurrentConversation(
            data.conversation
          );
          // 职位卡片
          const res: any = await getJobInfo(jobId);
          if (res?.code === API_RESULT_CODE.SUCCESS) {
            const {
              district_list,
              company_id,
              company_name,
              company_info,
              job_id,
              job_name,
              nature_cn,
              experience_cn,
              education_cn,
              max_wage,
              min_wage,
              months,
              wage_unit,
              wage_unit_cn,
              is_negotiable,
            } = res.data;
            const address = district_list?.map((item: any) => item.area_cn);
            const jobInfo = {
              businessID: "job",
              company_id,
              company_logo: company_info?.show_logo,
              company_name,
              company_nature: company_info?.nature_cn,
              job_address: address?.join(","),
              job_attribs: [nature_cn, experience_cn, education_cn],
              job_id,
              job_salary: getWage(
                min_wage,
                max_wage,
                wage_unit,
                wage_unit_cn,
                is_negotiable,
                months
              ),
              job_title: job_name,
              version: 4,
            };
            TUICore.instance.TUIServer.TUIChat.sendCustomMessage({
              data: jobInfo,
            });
            // 文本
            TUICore.instance.TUIServer.TUIChat.sendTextMessage(
              "您好，我对贵公司发布的岗位很感兴趣，可以详细聊聊吗？"
            );
          }
        }
      );
    };
    // 创建客服会话
    const createConversationKefu = (imId: string) => {
      const conversationID = `C2C${imId}`;
      TUICore.instance.TUIServer.TUIConversation.getConversationProfile(conversationID).then(
        async (imResponse: any) => {
          const { data } = imResponse;
          data.currentConversationID = conversationID;
          // 通知 TUIConversation 模块切换当前会话
          await TUICore.instance.TUIServer.TUIConversation.handleCurrentConversation(
            data.conversation
          );
        }
      );
    };

    const handleCurrentConversation = (value: string) => {
      data.currentConversationID = value;
    };
    const setReadReceipt = (value: boolean) => {
      store.commit("setNeedReadReceipt", value);
    };
    const setDisplayOnlineStatus = (value: boolean) => {
      store.commit("setDisplayOnlineStatus", value);
    };
    const setNotification = (value: boolean) => {
      store.commit("setNotification", value);
      TUINotification.getInstance().setNotificationConfiguration({
        allowNotifications: value,
      });
    };
    const beforeCalling = (type: string, error: any) => {
      if (error) {
        handleErrorPrompts(error, type);
        data.showCall = false;
        return;
      }
      data.showCall = true;
    };
    const afterCalling = () => {
      data.showCall = false;
      data.showCallMini = false;
    };
    const onMinimized = (oldMinimizedStatus: boolean, newMinimizedStatus: boolean) => {
      data.showCall = !newMinimizedStatus;
      data.showCallMini = newMinimizedStatus;
    };

    const onMessageSentByMe = async (message: any) => {
      const TUIServer = (window as any)?.TUIKitTUICore?.TUIServer;
      TUIServer?.TUIChat?.handleMessageSentByMeToView(message);
      return;
    };
    // 返回首页
    const toHome = () => {
      window.location.href = process.env.VUE_APP_HOST;
    };
    return {
      ...toRefs(data),
      taskList,
      version,
      handleCurrentConversation,
      setReadReceipt,
      isMsgNeedReadReceipt,
      setDisplayOnlineStatus,
      displayOnlineStatus,
      allowNotification,
      setNotification,
      beforeCalling,
      afterCalling,
      onMinimized,
      onMessageSentByMe,
      toHome,
      hideTabbar,
    };
  },
});
